import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=157e02af&scoped=true"
import script from "./Approval.vue?vue&type=script&lang=js"
export * from "./Approval.vue?vue&type=script&lang=js"
import style0 from "./Approval.vue?vue&type=style&index=0&id=157e02af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e02af",
  null
  
)

export default component.exports